import * as server from "@/utils/http"

export const _pages = params => server.get("/referral-department/pages", params);

export const _get = params => server.get("/referral-department/get", params);

export const _save = params => server.post(params.id ? "/referral-department/update" : "/referral-department/save", params);

export const _updateStatus = params => server.get("/referral-department/updateStatus", params);


